import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const breadcrumbLabels = {
  '/': 'Accueil',
  '/products': 'Produits',
  '/products/pains': 'Pains',
  '/products/patisserie': 'Pâtisserie',
  '/products/boissons': 'Boissons',
  '/products/specialites': 'Spécialités',
  '/about': 'À propos',
  '/heritage': 'Notre héritage',
  '/commitments': 'Nos engagements',
  '/franchise': 'Devenir franchisé',
  '/services': 'Services',
  '/themes': 'Thèmes'
};

export function Breadcrumb({ className = '' }) {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  if (pathnames.length === 0) {
    return null; // Don't show breadcrumb on homepage
  }

  return (
    <nav className={`flex ${className}`} aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        <li className="inline-flex items-center">
          <Link 
            to="/" 
            className="inline-flex items-center text-sm font-medium text-text-secondary hover:text-accent transition-colors duration-150"
          >
            <span className="material-symbols-outlined mr-2 text-sm">home</span>
            Accueil
          </Link>
        </li>
        {pathnames.map((pathname, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          const label = breadcrumbLabels[routeTo] || pathname.charAt(0).toUpperCase() + pathname.slice(1);

          return (
            <li key={routeTo}>
              <div className="flex items-center">
                <span className="material-symbols-outlined mx-1 text-text-muted text-sm">chevron_right</span>
                {isLast ? (
                  <span className="ml-1 md:ml-2 text-sm font-medium text-text-primary">
                    {label}
                  </span>
                ) : (
                  <Link
                    to={routeTo}
                    className="ml-1 md:ml-2 text-sm font-medium text-text-secondary hover:text-accent transition-colors duration-150"
                  >
                    {label}
                  </Link>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumb;
